/* assumes parent object has a RgpOptions prop
rgpOptions has this structure
{
    "companies":{"id":{"name":"xxx","id":"x"},..},
    "materials":{"id":{"id":"x","name":"xxx","companyId":"x"},..},
    "companiesOrder":["9","8","4","7",...],
    "lensCompaniesOrder":["6",. . .],
    "materialCompaniesOrder":["7",. . .],
    "materialsOrder":["66",. . .],
    "materialsByCompany":{"compid":["matid1","matid2", . . .], . . .},
    "tags":{"tagid":{"slug":"xxx","name":"xxx"}, . . .},
    "tagGroups":{"tagid":[tagid1, tagid2, . . .], . . .}
*/
export default {
  data: function () {
    return {
      companyLogoPath: "https://www.eyedock.com/images/rgp_companies/",
      iconPath: "https://eyedock.com/images/menu_icons/",
      lensTypeTitles: {
        corneal: "Corneal",
        scleral: "Scleral Lenses",
        "ortho-k": "CRT / Ortho-K lenses",
      },
      imagesForKey: {
        corneal: "rgp_icon.svg",
        scleral: "scleral_icon.svg",
        presbyopia: "rgp_bifocal_icon.svg",
        all: "all_rgps_icon.svg",
        "irregular-cornea": "topography_icon.svg",
        "ortho-k": "ortho_k_icon.svg",
      },
      keyTitles: {
        corneal: "Corneal Lenses",
        scleral: "Scleral Lenses",
        presbyopia: "Lenses for Presbyopia",
        all: "All GP / Specialty Lenses",
        "irregular-cornea": "Lenses for Irregular Corneas",
        "ortho-k": "CRT / Ortho-K Lenses",
      },
    };
  },
  methods: {
    // returns the tag id for a tag slug (i.e. "presbyopia")
    getTagIdForSlug(slug) {
      return this.tagIdsForSlugs[slug];
    },
    tagObjForId(id) {
      let tag = this.rgpOptions?.tags?.[id];
      return tag ? tag : null;
    },
    tagObjForSlug(slug) {
      let id = this.tagIdsForSlugs?.[slug];
      return id ? this.tagObjForId(id) : null;
    },
    companyObjForId(id) {
      let company = this.rgpOptions?.companies?.[id];
      return company ? company : null;
    },
    companyObjForSlug(slug) {
      let id = this.companyIdsForSlugs?.[slug];
      return id ? this.companyObjForId(id) : null;
    },

    companySlugForId(id) {
      //   console.log(id);
      let compObj = this.companyObjForId(id);
      //   console.log(compObj);
      return compObj ? compObj.slug : null;
    },
    companyNameForSlug(slug) {
      //   console.log(id);
      let compObj = this.companyObjForSlug(slug);
      //   console.log(compObj);
      return compObj ? compObj.name : null;
    },
    companyNameForId(id) {
      //   console.log(id);
      let compObj = this.companyObjForId(id);
      //   console.log(compObj);
      return compObj ? compObj.name : null;
    },
    companyImageForId(id) {
      let compObj = this.companyObjForId(id);
      return compObj ? this.companyLogoPath + compObj.image : null;
    },
    // materialCompanyObjForId(id) {
    //   let company = this.rgpOptions?.materialCompanies?.[id];
    //   return company ? company : null;
    // },
    materialObjForId(id) {
      let material = this.rgpOptions?.materials?.[id];
      return material ? material : null;
    },
    materialNameForId(id) {
      let materialObj = this.materialObjForId(id);
      return materialObj ? materialObj.name : null;
    },
    // materialCompanyNameForId(id) {
    //   //   console.log(id);
    //   let compObj = this.materialCompanyObjForId(id);
    //   //   console.log(compObj);
    //   return compObj ? compObj.name : null;
    // },
    materialTypeObjForId(id) {
      let typeObj = this.rgpOptions?.materialTypes?.[id];
      return typeObj ? typeObj : null;
    },
    materialTypeNameForId(id) {
      let typeObj = this.materialTypeObjForId(id);
      return typeObj ? typeObj.name : null;
    },

    companyOptionsForList(ids) {
      let allIds = this.rgpOptions?.companiesOrder;
      let companiesById = this.rgpOptions?.companies;
      if (!allIds || !companiesById) return null;
      let rtn = [];
      allIds.forEach((id) => {
        if (ids.includes(id)) {
          let comp = companiesById[id];
          let obj = { text: comp.name, value: comp.slug };
          rtn.push(obj);
        }
      });
      return rtn;
    },

    tagIdArrForSlugArr(slugArr) {
      let rtn = [];
      let ids4slugs = this.tagIdsForSlugs;
      let tagObjs = this.rgpOptions?.tags;
      if (!tagObjs) return rtn;
      slugArr.forEach((slug) => {
        if (ids4slugs[slug]) rtn.push(ids4slugs[slug]);
      });
      return rtn;
    },

    tagOptionsForSelect(activeTags) {
      let groups = this.rgpOptions?.tagGroups;
      let tags = this.rgpOptions?.tags;
      if (!groups || !tags) return null;
      let groupIds = Object.keys(groups);
      let rtn = [];
      groupIds.forEach((gKey) => {
        const gItem = tags[gKey];
        if (activeTags.includes(gKey))
          rtn.push({
            text: gItem.name,
            value: gKey,
            // disabled: !activeTags.includes(gKey),
          });
        let idArr = groups[gKey];
        idArr.forEach((tagKey) => {
          const tItem = tags[tagKey];
          const name = `${gItem.name} : ${tItem.name}`;
          if (activeTags.includes(tagKey))
            rtn.push({
              text: name,
              value: tagKey,
              // disabled: !activeTags.includes(tagKey),
            });
        });
      });
      return rtn;
    },
    // takes an array of tag ids and a child tag id
    // finds all the parents of the child id and adds them to the array
    addChildTagAndParents(tagList, childId) {
      if (!tagList.includes(childId)) tagList.push(childId);
      let childObj = this.rgpOptions?.tags[childId];

      let parentId = childObj.parentId;
      if (parentId) {
        let parentActive = tagList.includes(parentId);
        if (!parentActive) tagList.push(String(parentId));
        // now see if the parent's parent is active..
        tagList = this.addChildTagAndParents(tagList, parentId);
      }
      return tagList;
    },

    removeTagAndChildren(tagList, parentId) {
      // first, remove the tag from the list (if needed)
      if (tagList.includes(parentId))
        tagList = tagList.filter((e) => e !== parentId);

      let kidIds = this.kidsWithParentId(parentId);
      if (kidIds) {
        let that = this;
        kidIds.forEach((id) => {
          tagList = tagList.filter((e) => e !== id);
          tagList = that.removeTagAndChildren(tagList, id);
        });
      }
      return tagList;
    },

    // unselectChildTags(parentId) {
    //   let kidIds = this.kidsWithParentId(parentId);
    //   let that = this;
    //   kidIds.forEach((id) => {
    //     that.uncheckId(id);
    //     that.unselectChildTags(id);
    //   });
    // },
    kidsWithParentId(id) {
      let rtn = [];
      let allTags = this.rgpOptions?.tags;
      let allTagIds = Object.keys(allTags);
      allTagIds.forEach((tId) => {
        const obj = allTags[tId];
        if (obj.parentId == id) rtn.push(tId);
      });
      return rtn;
    },

    // uncheckId(id) {
    //   this.localTags = this.localTags.filter((e) => e !== id);
    // },
  },
  computed: {
    // gets tag ids for slugs
    tagIdsForSlugs: function () {
      let rtn = {};

      let tagObjs = this.rgpOptions?.tags;
      if (!tagObjs) return null;

      let keys = Object.keys(tagObjs);
      keys.forEach((id) => {
        let slug = tagObjs[id]["slug"];
        rtn[slug] = id;
      });

      // if (!this.rgpOptions) return rtn;
      // rtn.presbyopia = this.getTagIdForSlug("presbyopia");
      // rtn.toric = this.getTagIdForSlug("toric");
      // rtn.scleral = this.getTagIdForSlug("scleral");
      // rtn["ortho-k"] = this.getTagIdForSlug("ortho-k");
      return rtn;
    },

    companyIdsForSlugs() {
      let companiesById = this.rgpOptions?.companies;
      if (!companiesById) return null;
      let rtn = {};
      let ids = Object.keys(companiesById);
      ids.forEach((id) => {
        let obj = companiesById[id];
        rtn[obj.slug] = id;
      });
      return rtn;
    },

    // companyObjectsArray: function () {
    //   let m = this.rgpOptions;
    //   let rtn = [];
    //   if (!m) return rtn;
    //   if (m.companies)
    //     rtn = this.rgpOptions.companiesOrder.map((id) => {
    //       return m.companies[id];
    //     });
    //   return rtn;
    // },
  },
};
